import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { OrderDetailsBus } from '@app/cp/shared/models/OrderDetailsBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventorySuppliersBus } from '@app/cp/shared/models/InventorySuppliersBus';
import { VendorReturnDetailBus } from '@app/cp/shared/models/VendorReturnDetailBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'vendor-return-parts',
    templateUrl: './vendor-return-parts.component.html',
    styleUrls: ['./vendor-return-parts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VendorReturnPartsComponent extends BaseGridEditLineComponent<VendorReturnDetailBus, null, OrderService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "VendorReturnDetailBus";
    }

    @Input() defaultInventory: VendorReturnDetailBus[] = [];
    //@Input() defaultOrderId: any;

    createForm() {
        this.editForm = new UntypedFormGroup({
            'vendorReturnDetailId': new UntypedFormControl(),
            'vendorReturnId': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'qtyToReturn': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl(),
            'isWarranty': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),

            'deductedQty': new UntypedFormControl(),
            'deductedDate': new UntypedFormControl(),
            'returnNote': new UntypedFormControl(),
            'number': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(),
            'dispatchNumber': new UntypedFormControl(),
            'orderNumber': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            vendorReturnDetailId: this.selectedData.vendorReturnDetailId,
            vendorReturnId: this.selectedData.vendorReturnId,
            orderId: this.selectedData.orderId,
            dispatchId: this.selectedData.dispatchId,
            qtyToReturn: this.selectedData.qtyToReturn,
            inventoryId: this.selectedData.inventoryId,
            isWarranty: this.selectedData.isWarranty,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,

            deductedQty: this.selectedData.deductedQty,
            deductedDate: this.selectedData.deductedDate,
            returnNote: this.selectedData.returnNote,
            number: this.selectedData.number,
            inventoryDesc: this.selectedData.inventoryDesc,
            dispatchNumber: this.selectedData.dispatchNumber,
            orderNumber: this.selectedData.orderNumber
        });
    }
    dispatchSearch: boolean = false;

    protected save(dataObj: VendorReturnDetailBus) {

    }
    costChange(event, dataItem, editForm) {

    }
    muChange(event, dataItem: OrderDetailsBus, editForm) {
        let mu = (event * 1) / 100;
    }
    public accountClass(id: string) {
        return this.referenceData.accountClasses.find(x => x.value === id);
    }
    partSuppliers: InventorySuppliersBus[];
    partSuppliersActive: boolean = false;
    partSuppliersHeight: number = 0;
    showInventorySuppliers(dataItem: OrderDetailsBus) {
        this.svc_inv.getInventorySuppliers(dataItem.inventoryId).subscribe((data: InventorySuppliersBus[]) => {
            if (CommonFunctions.hasArrayValue(data)) {
                if (data.length > 20) {
                    this.partSuppliersHeight = 600;
                }
                else {
                    this.partSuppliersHeight = 0;
                }
            }
            this.partSuppliers = data;
            this.partSuppliersActive = true;
        });
    }
    closePartSupplier() {
        this.partSuppliersActive = false;
    }

}
